export const ja = {
  // Common
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    back: '戻る',
    close: '閉じる',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    ok: 'OK',
    submit: '送信',
    reset: 'リセット',
    clear: 'クリア',
    view: '表示',
    details: '詳細',
    settings: '設定',
    logout: 'ログアウト',
    login: 'ログイン',
    signup: 'サインアップ',
    profile: 'プロフィール',
    collection: 'コレクション',
    insights: 'インサイト',
    overview: '概要',
    categories: 'カテゴリ',
    preorders: '予約注文',
    recent: '最近',
    total: '合計',
    average: '平均',
    price: '価格',
    quantity: '数量',
    author: '著者',
    publisher: '出版社',
    isbn: 'ISBN',
    genre: 'ジャンル',
    type: 'タイプ',
    language: '言語',
    source: 'ソース',
    date: '日付',
    status: 'ステータス',
    value: '価値',
    items: 'アイテム',
    owned: '所有',
    preorder: '予約注文',
    created: '作成日',
    updated: '更新日',
    title: 'タイトル',
    description: '説明',
    image: '画像',
    currency: '通貨',
    preferences: '設定',
    clone: '複製',
    cloneSuccess: '本が正常に複製されました',
    cloneError: '本の複製に失敗しました',
    code: 'コード'
  },

  // Navigation
  nav: {
    home: 'ホーム',
    collection: 'コレクション',
    insights: 'インサイト',
    wishlist: 'ウィッシュリスト',
    settings: '設定',
    profile: 'プロフィール',
    logout: 'ログアウト',
    language: '言語'
  },

  // Landing Page
  landing: {
    title: 'BookPort',
    subtitle: 'あなたの個人図書コレクション管理ツール',
    description: '本のコレクションを簡単に整理、追跡、管理できます。小説から教科書まで、すべてを美しく整理された場所に保管します。',
    getStarted: '始める',
    signUp: 'サインアップ',
    goToCollection: 'コレクションへ',
    sampleCollection: 'サンプルコレクション',
    features: {
      title: '強力な機能',
      subtitle: '本のコレクション管理に必要なすべて',
      completeManagement: {
        title: '完全な本の管理',
        description: '著者、出版社、ジャンルなどの詳細情報で本のコレクション全体を整理します。'
      },
      smartSearch: {
        title: 'スマート検索',
        description: 'タイトル、著者、ISBN、出版社による強力な検索で、コレクション内の任意の本を瞬時に見つけます。'
      },
      multiCurrency: {
        title: 'マルチ通貨サポート',
        description: '自動為替レート更新で希望する通貨で本の価値を追跡します。'
      },
      bookTracking: {
        title: '本の追跡',
        description: '読書の進捗、本の状態、時間の経過によるコレクションの成長を追跡します。'
      },
      cloudSync: {
        title: 'クラウド同期',
        description: '安全なクラウド同期でどこからでも本のコレクションにアクセスできます。'
      },
      secure: {
        title: '安全でプライベート',
        description: '本のコレクションデータはプライベートで安全です。エンタープライズレベルの暗号化を使用しています。'
      }
    },
    howItWorks: {
      title: '使い方',
      subtitle: 'シンプルな数ステップで始められます',
      signUp: {
        title: 'サインアップ',
        description: '数秒で無料アカウントを作成'
      },
      addBooks: {
        title: '本を追加',
        description: '詳細な情報で本を追加'
      },
      organize: {
        title: '整理',
        description: 'ジャンル、著者、または任意の基準で整理'
      },
      monitor: {
        title: '監視',
        description: 'コレクションの成長と価値を監視'
      }
    },
    benefits: {
      title: 'なぜBookPortを選ぶのか？',
      subtitle: 'コレクション管理にBookPortを信頼する何千人もの本愛好家に参加してください',
      neverLose: '本を見失うことはありません',
      trackValue: 'コレクションの価値を追跡',
      planPurchases: '次の本の購入を計画',
      shareCollection: '友達とコレクションを共有',
      mobileFriendly: '任意のデバイスからアクセス',
      freeToUse: '完全に無料'
    },
    readerTypes: {
      title: 'すべての読者に最適',
      description: '小説、教科書、漫画、希少本を収集するかどうかにかかわらず、BookPortがあなたの収集スタイルに適応します。',
      startCollection: 'コレクションを始める'
    },
    cta: {
      title: '本の整理を準備しましたか？',
      subtitle: 'すでにBookPortでコレクションを整理している何千人もの本愛好家に参加してください。',
      createAccount: 'アカウントを作成'
    }
  },

  // Collection
  collection: {
    title: 'マイ本コレクション',
    addNewBook: '新しい本を追加',
    addBook: '本を追加',
    searchPlaceholder: 'タイトル、著者、ISBN、または出版社で検索...',
    noBooks: 'コレクションに本がまだありません。',
    noSearchResults: '検索に一致する本が見つかりません。',
    addFirstBook: '最初の本を追加',
    startBuildingCollection: '最初の本を追加してコレクションを始めましょう！',
    tryAdjustingSearch: '検索条件を調整してみてください。',
    showingResults: '{total}冊中{count}冊を表示',
    endOfResults: 'コレクションの最後に到達しました',
    viewDetailedInsights: '詳細インサイトを表示',
    summary: {
      title: '大切な本のコレクションを追跡・整理',
      totalBooks: '総本数',
      foundBooks: '見つかった本',
      totalValue: '総価値',
      averagePrice: '平均価格',
      totalQuantity: '総数量'
    }
  },

  // Book Detail
  bookDetail: {
    newBook: '新しい本を追加',
    editBook: '本を編集',
    title: 'タイトル',
    author: '著者',
    isbn: 'ISBN',
    publisher: '出版社',
    series: 'シリーズ',
    genre: 'ジャンル',
    type: 'タイプ',
    language: '言語',
    price: '価格',
    quantity: '数量',
    source: 'ソース',
    imageUrl: '画像URL',
    createdDate: '作成日',
    notes: 'メモ',
    save: '本を保存',
    cancel: 'キャンセル',
    delete: '本を削除',
    deleteConfirm: 'この本を削除してもよろしいですか？',
    deleteConfirmDescription: 'この操作は元に戻せません。',
    imagePlaceholder: '画像なし'
  },

  // Insights
  insights: {
    title: 'コレクションインサイト',
    subtitle: '本のコレクションに関する詳細な分析とインサイト',
    overview: {
      title: '概要',
      collectionStatus: 'コレクション状況',
      ownedItems: '所有アイテム',
      preorderItems: '予約注文アイテム',
      valueBreakdown: '価値の内訳',
      ownedValue: '所有価値',
      preorderValue: '予約価値',
      mostValuableItems: '最も価値の高いアイテム'
    },
    categories: {
      title: 'カテゴリ',
      topPublishers: '人気出版社',
      topGenres: '人気ジャンル',
      topTypes: '人気タイプ',
      topLanguages: '人気言語',
      topSources: '人気ソース'
    },
    preorders: {
      title: '予約注文',
      preorderSummary: '予約注文概要',
      items: 'アイテム',
      totalValue: '総価値'
    },
    recent: {
      title: '最近',
      recentAdditions: '最近追加されたアイテム'
    },
    stats: {
      totalItems: '総アイテム数',
      totalValue: '総価値',
      totalQuantity: '総数量',
      averagePrice: '平均価格'
    }
  },

  // Settings
  settings: {
    title: 'ユーザー設定',
    currency: '通貨',
    language: '言語',
    saveSettings: '設定を保存',
    settingsSaved: '設定が正常に保存されました！',
    settingsError: '設定の保存に失敗しました',
    currencyDescription: 'アプリケーション全体で価格を表示するための希望する通貨を設定してください。すべての価格は選択した通貨に変換されます。',
    languageDescription: 'アプリケーションインターフェースの希望する言語を選択してください。言語は即座に適用されます。',
    preferences: '設定'
  },

  // Auth
  auth: {
    login: {
      title: 'BookPortにサインイン',
      email: 'メール',
      password: 'パスワード',
      signIn: 'サインイン',
      signInWithGoogle: 'Googleでサインイン',
      noAccount: 'アカウントをお持ちでない場合',
      signUp: 'サインアップ',
      forgotPassword: 'パスワードを忘れた場合',
      loginError: 'ログインに失敗しました'
    },
    signup: {
      title: 'アカウントを作成',
      displayName: '表示名',
      email: 'メール',
      password: 'パスワード',
      confirmPassword: 'パスワード確認',
      signUp: 'サインアップ',
      signUpWithGoogle: 'Googleでサインアップ',
      haveAccount: 'すでにアカウントをお持ちの場合',
      signIn: 'サインイン',
      signupError: 'アカウントの作成に失敗しました',
      passwordMismatch: 'パスワードが一致しません'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: 'ウィッシュリスト',
    subtitle: 'コレクションに追加したい本を追跡',
    addNewWish: 'ウィッシュアイテムを追加',
    addFirstWish: '最初のウィッシュアイテムを追加',
    searchPlaceholder: 'ウィッシュリストアイテムを検索...',
    noWishItems: 'ウィッシュリストにアイテムがありません。',
    noSearchResults: '検索に一致するウィッシュリストアイテムが見つかりません。',
    showingResults: '{total}件中{count}件を表示',
    convertToBook: '本に変換',
    convert: 'はい、手に入れました！',
    converting: '変換中...',
    convertConfirm: '手に入れましたか？',
    convertConfirmDescription: 'このアイテムをウィッシュリストからコレクションに移動します。その後、数量とソース情報を追加できます。',
    deleteConfirm: 'ウィッシュアイテムを削除しますか？',
    deleteConfirmDescription: 'このウィッシュアイテムを完全に削除します。この操作は元に戻せません。',
    // New celebratory conversion messages
    congratulations: '🎉 おめでとうございます！🎉',
    finallyGotIt: 'ついに手に入れましたね！',
    thatsAwesome: '素晴らしいです！🎊 この美しい本をウィッシュリストからコレクションに移動する時が来ました。数量や入手先などの詳細を追加できます。',
    readyToCelebrate: 'コレクションへの追加を祝う準備はできましたか？',
    maybeLater: 'また後で',
    yesAddToCollection: '🎉 はい、コレクションに追加！',
    addingToCollection: 'コレクションに追加中...'
  },

  // Currencies
  currencies: {
    USD: '米ドル',
    THB: 'タイバーツ',
    JPY: '日本円',
    CNY: '中国人民元'
  },


}; 